import * as React from 'react';

const SvgCloseCrossSmall = React.forwardRef(({ size = 16, ...props }, ref) => (React.createElement("svg", { "data-testid": "svg-close-cross-small", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: "none", viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M3.293 11.293a1 1 0 1 0 1.414 1.414L8 9.414l3.293 3.293a1 1 0 0 0 1.414-1.414L9.414 8l3.293-3.293a1 1 0 0 0-1.414-1.414L8 6.586 4.707 3.293a1 1 0 0 0-1.414 1.414L6.586 8z" }))));
SvgCloseCrossSmall.displayName = 'SvgCloseCrossSmall';

export { SvgCloseCrossSmall };
